export default value => {
  if(value){
    switch(value){
      case 'BRL':
        return 'R$';
      case 'USD':
        return 'US$';
      case 'EUR':
        return '€';
      default:
        return '$';
    }
  }
};
